var $eebc33d740a6a571$exports = {};
$eebc33d740a6a571$exports = {
    "collapse": `Samenvouwen`,
    "expand": `Uitvouwen`
};


export {$eebc33d740a6a571$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
